// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M13.0035 2.00195L11.0035 1.99805L11.0014 3.08266C8.48696 3.50372 6.50245 5.48865 6.08203 8.00333H17.9172C17.497 5.48984 15.5142 3.5056 13.0014 3.08326L13.0035 2.00195Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 10H2V12H3V22H8V16H16V22H21V12H22V10Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M10 22V18H14V22H10Z"}}]};

const MosqueFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'mosque-filled',
    ref,
    icon: element,
  },
));

MosqueFilledIcon.displayName = 'MosqueFilledIcon';

export default MosqueFilledIcon;
